export enum StorageFilterErrorCode {
    NONE = "",
    QUERY_FILTER_FAILED = "query_filter_failed",
    FAIL_CREATE_TABLE = "fail_create_table"
}
